import axios from "axios";
import config from "../Config/Config";
import strings from "../Utils/strings";
import { msalConfig } from "../authConfig";
import authService from "../Services/authService";
import { PublicClientApplication } from "@azure/msal-browser";
const msalInstance = new PublicClientApplication(msalConfig);
const api = axios.create({
  baseURL: config.baseURL,
});
const signOutClickHandler = async () => {
  try {
    await msalInstance.initialize();
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      const homeAccountId = accounts[0].homeAccountId;
      const logoutRequest = {
        account: msalInstance.getAccountByHomeId(homeAccountId),
        mainWindowRedirectUri: config.azureRedirect,
      };
      await msalInstance.logoutPopup(logoutRequest);
    }
  } catch (error) {
    console.error("Logout failed: ", error);
  }
};

api.interceptors.request.use(
  (config) => {
    getRefreshTokenFromLocalStorage();
    const accessToken = authService.getToken();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    const language = localStorage.getItem("i18nextLng");
    if (language) {
      let langCode;
      switch (language) {
        case "en-US":
          langCode = "en";
          break;
        case "vietnam":
          langCode = "vi";
          break;
        case "french":
          langCode = "fr";
          break;
        case "en":
          langCode = "en";
          break;
        default:
          langCode = "en";
      }
      config.headers["Accept-Language"] = langCode;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.message === "Unauthorized Access"
    ) {
      signOutClickHandler();
    }
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.message === "token is not found"
    ) {
      signOutClickHandler();
    }
    return Promise.reject(error);
  }
);

function getRefreshTokenFromLocalStorage() {
  const fvToken = localStorage.getItem(strings.refreshToken);
  if (fvToken) {
    return fvToken
  } else {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.includes("refreshtoken")) {
        try {
          const tokenData = JSON.parse(localStorage.getItem(key));
          if (tokenData && tokenData.secret && tokenData.secret.length > 0) {
            return tokenData.secret;
          }
        } catch (error) {
          console.error("Error parsing token data from localStorage:", error);
        }
      }
    }
  }

  return null;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.message === "jwt is expired"
    ) {
      try {
        const refreshToken = getRefreshTokenFromLocalStorage();

        if (refreshToken) {
          const url =
            "https://login.microsoftonline.com/c717746a-f099-449f-afb1-7545611404b2/oauth2/v2.0/token";
          const formData = new URLSearchParams();
          formData.append("grant_type", "refresh_token");
          formData.append("refresh_token", refreshToken);
          formData.append(
            "scope",
            "api://5aba4238-1e5f-4a18-9f29-20cf7d720667/fv.service.read&write"
          );

          const tokenResponse = await axios.post(url, formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });
          const newAccessToken = tokenResponse.data.access_token;
          const newRefreshToken = tokenResponse.data.refresh_token;
          authService.setToken(newAccessToken);
          localStorage.setItem(strings.clinicLogin.label_session, newRefreshToken);
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          window.location.reload();
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error("Error refreshing token:", refreshError);
        if(refreshError.response.data.error && refreshError.response.data.error_codes.length > 0){
          signOutClickHandler();
        }
        return Promise.reject("jwt is expired");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
